// extracted by mini-css-extract-plugin
export default {"heroProducts":"heroProducts_heroProducts__Y7EDd","heroProductsAnimated":"heroProducts_heroProductsAnimated__ggVos","wiggle":"heroProducts_wiggle__pKrUp"};